import dotPropImmutable from 'dot-prop-immutable';
import { findLargestSumOfStartDayDuration, findLowestStartDay } from '../utils';
export const tableSlice = {
    setProjectTemplateActiveRecord: (state, { payload: { id, type, data, taskId } })=>{
        if (!id) {
            return dotPropImmutable.set(state, 'activeRecord', undefined);
        }
        return dotPropImmutable.set(state, 'activeRecord', {
            id,
            key: `${type}-${id}`,
            type,
            data,
            taskId
        });
    },
    setProjectTemplateRecordForShowingVariablesSelect: (state, { payload: { id, type } })=>{
        if (!id) {
            return dotPropImmutable.set(state, 'recordForShowingVariablesSelect', undefined);
        }
        return dotPropImmutable.set(state, 'recordForShowingVariablesSelect', {
            id,
            key: `${type}-${id}`,
            type
        });
    },
    clearProjectTemplateRecordForShowingVariablesSelect: (state)=>{
        return {
            ...state,
            recordForShowingVariablesSelect: undefined
        };
    },
    clearProjectTemplateActiveRecord: (state)=>{
        return {
            ...state,
            activeRecord: undefined
        };
    },
    updateProjectTemplateStartdayDuration: (state, { payload })=>{
        const payloadTask = state.data[state.activeId].tasks[payload.taskId];
        let result = state;
        const calculateValuesOfParent = (task)=>{
            if (task.parentTask) {
                const parentTask = dotPropImmutable.get(result, `data.${state.activeId}.tasks.${task.parentTask.taskId}`);
                const parentTasksSubTasks = parentTask.subTasks.map((subTaskId)=>dotPropImmutable.get(result, `data.${state.activeId}.tasks.${subTaskId}`));
                const parentStartDay = findLowestStartDay(parentTasksSubTasks);
                const largestDuration = findLargestSumOfStartDayDuration(parentTasksSubTasks);
                const difference = largestDuration - parentStartDay;
                result = dotPropImmutable.merge(result, `data.${state.activeId}.tasks.${parentTask.taskId}`, {
                    startDay: parentStartDay,
                    duration: difference
                });
                calculateValuesOfParent(parentTask);
            }
            if (task.projectPhase) {
                const parentProjectPhase = dotPropImmutable.get(result, `data.${state.activeId}.projectPhases.${task.projectPhase.projectPhaseId}`);
                const parentTasks = parentProjectPhase.tasks.map((taskId)=>dotPropImmutable.get(result, `data.${state.activeId}.tasks.${taskId}`)).filter((t)=>!t.isNew);
                const parentStartDay = findLowestStartDay(parentTasks);
                const largestDuration = findLargestSumOfStartDayDuration(parentTasks);
                const difference = largestDuration - parentStartDay;
                result = dotPropImmutable.merge(result, `data.${state.activeId}.projectPhases.${parentProjectPhase.projectPhaseId}`, {
                    startDay: parentStartDay,
                    duration: difference
                });
            }
        };
        calculateValuesOfParent(payloadTask);
        return result;
    }
};
